import { render } from "./CoBrandObsidian.vue?vue&type=template&id=212fa7dd&scoped=true"
import script from "./CoBrandObsidian.vue?vue&type=script&lang=js"
export * from "./CoBrandObsidian.vue?vue&type=script&lang=js"

import "./CoBrandObsidian.vue?vue&type=style&index=0&id=212fa7dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212fa7dd"]])

export default __exports__